import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Button, Col, Modal, Row} from "react-bootstrap";

import {resetEntity, showMessage} from '../actions';
import {loadGeneralEnum} from "../actions/enums";
import {deleteParty, loadParty, saveParty} from '../actions/parties';
import {defaultState} from '../reducers/entity';
import PartyForm from '../components/party/PartyForm';
import {Acl, breadcrumbs, Grid} from "./../utils";

class PartyEditPage extends Component {

	constructor(props) {
		super(props);

		this.handleFetchEnums = this.handleFetchEnums.bind(this);
		this.handleSaveParty = this.handleSaveParty.bind(this);
		this.handleDeleteParty = this.handleDeleteParty.bind(this);
		this.handleOpenDeleteClick = this.handleOpenDeleteClick.bind(this);
		this.handleDismissDeleteClick = this.handleDismissDeleteClick.bind(this);

		this.state = {
			isDeleteModalOpen: false,
			deleteParty: null
		}
	}

	componentDidMount() {
		const partyId = (this.props.match.params.partyId || 'new')
		this.props.loadParty(partyId, 'new' !== partyId)
	}

	componentDidUpdate(prevProps) {
		const partyId = (this.props.match.params.partyId || 'new')
		if ((prevProps.match.params.partyId || 'new') !== partyId) {
			this.props.loadParty(partyId, 'new' !== partyId)
		}
	}

	componentWillUnmount() {
		this.props.resetEntity()
	}

	handleFetchEnums(enums) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], {})
			}
		}
	}

	handleSaveParty(party) {
		return this.props.saveParty(party).then((json) => {
			if (json && json.response && json.response.result === 'OK') {
				return new Promise((resolve, reject) => resolve(this.props.history.push('/parties')))
			} else {
				return new Promise((resolve, reject) => resolve())
			}
		})
	}

	handleOpenDeleteClick(party) {
		this.setState({isDeleteModalOpen: true, deleteParty: party})
	}

	handleDismissDeleteClick(e) {
		if (e) {
			e.preventDefault()
		}
		this.setState({isDeleteModalOpen: false, deleteParty: null})
	}

	handleDeleteParty(party) {
		return this.props.deleteParty(party.partyId).then((json) => {
			this.handleDismissDeleteClick();
			if (json && json.response && json.response.result === 'OK') {
				return new Promise((resolve, reject) => resolve(this.props.history.push('/parties')))
			}
		})
	}

	renderDeleteModal() {
		const {isDeleteModalOpen, deleteParty} = this.state;

		if (!isDeleteModalOpen) {
			return null
		}

		return (
			<Modal onHide={this.handleDismissClick} show={true}>
				<Modal.Header>
					<Modal.Title>Trvalé smazání subjektu</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<p>Skutečně trvale odstranit subjekt <strong>{deleteParty.title} ({deleteParty.abbr})</strong>? Takto akce je nevratná.</p>
				</Modal.Body>

				<Modal.Footer>
					<Row>
						<Col sm={12}>
							<Button variant={"link"} onClick={this.handleDismissDeleteClick}>Storno</Button>
							<Button type="submit" onClick={() => this.handleDeleteParty(deleteParty)} variant="danger">
								<span className="fa fa-trash"/> Trvale smazat subjekt</Button>
						</Col>
					</Row>
				</Modal.Footer>

			</Modal>
		)
	}

	render() {
		const {match: {params}, entity, session, enums} = this.props;

		if (entity.isFetchingItem || entity.item === null) {
			return Grid.renderIsFetchingData()
		}

		if ((!entity.partyId && !Acl.isAllowed(session, Acl.right.PARTY_NEW))
			|| (entity.partyId && !Acl.hasAction(entity.item, Acl.party.EDIT))) {
			return Grid.renderIsDenied()
		}

		const initialValues = entity.item;
		const bc = [
			{url: '/parties', title: 'Subjekty'}
		];
		if (params.partyId) {
			bc.push({url: '/parties/' + params.partyId, title: initialValues.abbr ? initialValues.abbr : '...'});
		} else {
			bc.push({url: '/parties/new', title: 'Nový'});
		}

		return (
			<div>
				<Row>
					<Col xs={12}>
						{breadcrumbs(bc)}
					</Col>
				</Row>
				<PartyForm {...entity} initialValues={initialValues}
					onSaveParty={this.handleSaveParty}
					onDeleteParty={this.handleOpenDeleteClick}
					onFetchEnums={this.handleFetchEnums} enums={enums} session={session}/>
				{this.renderDeleteModal()}
			</div>
		)
	}
}

PartyEditPage.propTypes = {
	entity: PropTypes.object.isRequired,
	loadParty: PropTypes.func.isRequired,
	saveParty: PropTypes.func.isRequired,
	deleteParty: PropTypes.func.isRequired,
	loadGeneralEnum: PropTypes.func.isRequired,
	enums: PropTypes.object,
	session: PropTypes.object.isRequired,
};


const mapStateToProps = (state, ownProps) => {
	const {
		entities: {parties},
		enums,
		session
	} = state;

	const entity = ownProps.match.params.partyId
		? (parties[ownProps.match.params.partyId] || defaultState)
		: (parties['new'] || Object.assign(defaultState, {item: {}}))

	return {
		entity,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadParty,
	saveParty,
	deleteParty,
	loadGeneralEnum,
	showMessage,
	resetEntity
})(PartyEditPage)
